import { Store } from "redux";

let timer_: Timer | null = null;

class Timer {
  store: Store;
  intervalID: Record<string, number>;

  constructor(store: Store) {
    this.store = store;
    this.intervalID = {};
  }

  start(name: string, interval: number): void {
    if (this.intervalID[name] !== undefined) {
      window.clearInterval(this.intervalID[name]);
    }

    this.intervalID[name] = window.setInterval(() => this.tick(name), interval);
  }

  cancel(name: string): void {
    if (this.intervalID[name] !== undefined) {
      clearInterval(this.intervalID[name]);
    }
  }

  tick(name: string) {
    this.store.dispatch({type: 'action/auto/tick', payload: name});
  }
}

export const createTimer = (store: Store): void => {
  timer_ = new Timer(store);
}

export const getTimer = (): Timer => {
  return timer_!;
}